import { termsService } from '@/services/terms';
import { useQuery } from '@tanstack/react-query';

interface TermsData {
  id: string;
  title: string;
  version: string;
  content: string;
  effectiveDate: string;
  isActive: boolean;
}

interface TermsServiceResult {
  success: boolean;
  data?: TermsData;
  error?: string;
}

export const useTerms = () => {
  return useQuery<TermsServiceResult, Error>({
    queryKey: ['terms'],
    queryFn: async () => {
      const result = await termsService.getTerms();

      if (!result.success) {
        throw new Error(result.error || 'Erro ao buscar termos de uso');
      }

      return result;
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
    retry: 2,
  });
};
